import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';

const NavigationHeader = dynamic(() => import('../../tissues/navigation-header'));
const CheckoutHeader = dynamic(() => import('../../molecules/checkout-header'));
const NavigationMenu = dynamic(() => import('../../tissues/navigation'));
const GlobalSearch = dynamic(() => import('../../tissues/search-global'));
const MobileNavigationMenu = dynamic(() => import('../../tissues/mobile-navigation'));
const PetiteDropDown = dynamic(() => import('../../tissues/petite-dropdown'));
const PromotionBanner = dynamic(() => import('../../tissues/promotion-copy'));
const SearchSuggestion = dynamic(() => import('../../tissues/search-global-suggestion'));

const Vestibule = (props) => (
  <>
    {
      props.isCheckout
        ? (
          <>
            <PromotionBanner content={props.promotionContent} />
            <CheckoutHeader />
          </>
        )
        : (
          <>
            <GlobalSearch isGlobalSearchActive={props.isGlobalSearchActive} />
            <SearchSuggestion />
            <PromotionBanner content={props.promotionContent} />
            <NavigationHeader />
          </>
        )
    }

    { props.user?.spree_api_key && <PetiteDropDown /> }

    {
      props.navigation !== null && (
        <NavigationMenu
          navigation={props.navigation}
          isCheckout={props.isCheckout}
        />
      )
    }

    {
      props.mobileNavigation !== null && (
        <MobileNavigationMenu
          navigation={props.mobileNavigation}
          profile={props.profile}
          isCheckout={props.isCheckout}
        />
      )
    }
  </>
);

Vestibule.defaultProps = {
  promotionContent: [],
  user: {},
  profile: {}
};

Vestibule.propTypes = {
  isGlobalSearchActive: PropTypes.bool.isRequired,
  navigation: PropTypes.object.isRequired,
  mobileNavigation: PropTypes.array.isRequired,
  promotionContent: PropTypes.array,
  user: PropTypes.object,
  profile: PropTypes.object,
  isCheckout: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  isGlobalSearchActive: state.interfaces.isGlobalSearchActive,
  user: state.user,
  profile: state.profile
});

const ConnectedVestibule = connect(mapStateToProps, null)(Vestibule);

Vestibule.whyDidYouRender = true;

export default ConnectedVestibule;
